import { ServiceNameKey, ServiceNameKeys } from '../util/serviceKeys';

export const additionalFeeNames: ReadonlyArray<ServiceNameKey> = [
  ServiceNameKeys.environmentalHandlingFee,
  ServiceNameKeys.suppliesAndShopFee,
  ServiceNameKeys.priorityServiceFee,
  ServiceNameKeys.mileageCharge,
  ServiceNameKeys.mobileServiceFee,
  ServiceNameKeys.mobileServiceFeeSubscription,
  ServiceNameKeys.mobileServiceFeeAllInclusiveSubscription,
  ServiceNameKeys.mobileServiceFeeAMZ,
  ServiceNameKeys.mobileServiceFeeAMZMainService,
];

export const discountedFeesNames: ReadonlyArray<ServiceNameKey> = [
  ServiceNameKeys.suppliesAndShopFee,
  ServiceNameKeys.environmentalHandlingFee,
];

export const discountIssuer = {
  groupon: 'GROUPON',
  gooil: 'GOOIL',
};
